import React from 'react';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const DetallePagoReferenciadoRealizado = ({ codProducto }) => {
  return (
    <div className="col-12 col-lg-11 text-center">
      {codProducto !== PRODUCTOS.SEGUKIDS && (
        <React.Fragment>
          <h1 className="font-mex text-mex">¡Felicidades!</h1>
          <h4 className="font-mex font-weight-light">
            Has completado el proceso, para realizar el pago de forma referenciado.
          </h4>
        </React.Fragment>
      )}

      {codProducto === PRODUCTOS.SEGUKIDS && (
        <React.Fragment>
          <h1 className="font-mex text-mex">
            ¡Felicidades!, muy pronto tus seres queridos estarán protegidos con AIG.
          </h1>
          <h4 className="font-mex font-weight-light">
            Has completado el proceso para realizar el pago por línea de captura.
          </h4>
        </React.Fragment>
      )}
    </div>
  );
};

export default DetallePagoReferenciadoRealizado;
